import { Routes } from '@angular/router';
import { ReloadComponent } from './core/components/reload.component';

export const appRoutes: Routes = [
  {
    path: '',
    pathMatch: 'full',
    redirectTo: 'registration'
  },
  {
    path: 'reload',
    pathMatch: 'full',
    component: ReloadComponent
  },
  {
    path: 'registration',
    loadChildren: () => import('./registration/registration.routes').then(m => m.registrationRoutes)
  },
  {
    path: 'inquiry',
    loadChildren: () => import('./inquiry/inquiry.routes').then(m => m.inquiryRoutes)
  },
  {
    path: 'portal',
    loadChildren: () => import('./portal/portal.routes').then(m => m.portalRoutes)
  }
];